module.exports = __webpack_public_path__ + "img/bg69.ec899de3.png";